import * as React from 'react';

import {Radio} from 'shells/radio/radio';
import {RadioGroup} from 'shells/radio/radio-group';
import {SavedSettingToast} from 'shells/saved-setting-toast/saved-setting-toast';

import type {CalendarFragment as Calendar} from 'nutshell-graphql-types';

import {useUpdateCalendarContactCreationRule} from './graphql/hooks/use-update-calendar-contact-creation-rule';
import {getComponentKey} from './helpers';

type Props = {
    calendar: Calendar | null | undefined;
    disabled: boolean;
    toolTip?: string;
};

export function CalendarContactCreationRuleRadioGroup(props: Props) {
    const [valueSaved, setValueSaved] = React.useState<boolean | null | undefined>(null);
    const savedTimeoutRef = React.useRef();
    const componentKey = React.useRef<string>(getComponentKey());

    const {updateCalendarContactCreationRule, isLoading} = useUpdateCalendarContactCreationRule();
    const isDisabled = props.disabled || !props.calendar || isLoading;

    // @ts-expect-error
    const handleChange = (value) => {
        if (props.calendar) {
            updateCalendarContactCreationRule({
                calendarId: props.calendar.id,
                isContactCreationDisabled: value === '0',
            }).then((mutationResult) => {
                setValueSaved(
                    mutationResult &&
                        mutationResult.data &&
                        mutationResult.data.calendarContactCreationRuleUpdate &&
                        mutationResult.data.calendarContactCreationRuleUpdate.calendar
                            .isContactCreationDisabled
                );
                if (savedTimeoutRef.current) {
                    clearTimeout(savedTimeoutRef.current);
                }
                // @ts-expect-error
                savedTimeoutRef.current = setTimeout(() => {
                    setValueSaved(null);
                }, 1000);
            });
        }
    };

    return (
        <RadioGroup
            name={`contact-creation-${componentKey.current}`}
            size='big'
            selectedValue={props.calendar && props.calendar.isContactCreationDisabled ? '0' : '1'}
            onChange={handleChange}
            toolTip={props.toolTip}
        >
            <SavedSettingToast state={valueSaved === false ? 'complete' : 'initial'}>
                <Radio value='1' disabled={isDisabled}>
                    Yes, create people in Nutshell for all new participants on activities
                </Radio>
            </SavedSettingToast>
            <SavedSettingToast state={valueSaved === true ? 'complete' : 'initial'}>
                <Radio value='0' disabled={isDisabled}>
                    No, don’t create people for new participants, I’ll do it myself
                </Radio>
            </SavedSettingToast>
        </RadioGroup>
    );
}
